module.exports = __webpack_public_path__ + "img/ring_of_aquila.b85ccefe.png";